module.exports = __webpack_public_path__ + "static/media/driver.a922a250.svg";